import { TriggerStrategy } from '@activepieces/pieces-framework';

export type TriggerMode = 'INSTANT' | 'PERIODIC' | 'MIXED';

export const triggerModeOf = (
  strategies: TriggerStrategy[],
): TriggerMode | null => {
  if (strategies.length === 0) {
    return null;
  }
  const pollingCount = strategies.filter(
    (strategy) => strategy === TriggerStrategy.POLLING,
  ).length;
  if (pollingCount === 0) {
    return 'INSTANT';
  }
  return pollingCount === strategies.length ? 'PERIODIC' : 'MIXED';
};
